import { render, staticRenderFns } from "./UpdateBaseInfo.vue?vue&type=template&id=32a63cec&scoped=true&"
import script from "./UpdateBaseInfo.vue?vue&type=script&lang=js&"
export * from "./UpdateBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./UpdateBaseInfo.vue?vue&type=style&index=0&id=32a63cec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a63cec",
  null
  
)

export default component.exports